import React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { titleCase } from "title-case";
import { sentenceCase } from 'change-case';
import { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { updateSelectedPrompt } from "../../app/promptsSlice";

function VariableFormControl({ variableName }: { variableName: string }) {
  const dispatch = useAppDispatch();
  const variables = useAppSelector(
    (state: RootState) => state.prompts.selectedPrompt.variables
  );
  const variable = variables[variableName as keyof typeof variables];

  const handleChange = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const newVariable = event.target.value;
    const newVariables = { ...variables, [variableName]: newVariable };
    dispatch(updateSelectedPrompt({ variables: newVariables }));
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          error={!variable || variable === ""}
          id={`${variableName}-textfield`}
          multiline
          label={titleCase(sentenceCase(variableName))}
          slotProps={{ inputLabel: { shrink: true } }}
          variant="outlined"
          value={variable}
          onChange={handleChange}
        />
      </FormControl>
    </Box>
  );
}

export default VariableFormControl;
